import angular from 'angular';
import RemoveHtmlTag from './remove-html-tag.filter';

export default angular
  .module('hireApp.remove-html-tag', [])
  .filter('removeHtmlTag', RemoveHtmlTag)
  .name;



// WEBPACK FOOTER //
// ./client/components/remove-html-tag/index.js